import { lazy } from 'react'

import CodeIcon from '@heroicons/react/outline/esm/CodeIcon.js'

import { I18nShape } from '@tribeplatform/react-components/i18n'

import { BlockType, RegisteredBlock } from '../../types/index.js'
import { HtmlScriptBlock as Component } from './Block.js'
import { HtmlScriptBlockProps } from './types.js'

const Settings = lazy(() =>
  import('./Settings.js').then(m => ({ default: m.HtmlScriptBlockSettings })),
)

export const RegisteredHtmlScriptBlock = (
  intl: I18nShape,
): RegisteredBlock<HtmlScriptBlockProps> => {
  const { $t } = intl

  return {
    recommendedName: 'HtmlScript',
    Component,
    config: {
      type: BlockType.Block,
      usable: true,

      displayName: $t({
        id: 'Blocks.HtmlScript.DisplayName',
        defaultMessage: 'Html Script',
      }),
      Settings,
      Icon: <CodeIcon />,
      defaultProps: {
        html: '',
        wrapper: 'card-with-padding',
      },
    },
  }
}
